import { AfterViewChecked, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { QRCodeRenderersOptions, toCanvas } from 'qrcode';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-pg-qrcode',
    templateUrl: './pg-qrcode.component.html',
    styleUrls: ['./pg-qrcode.component.scss'],
    standalone: false
})
export class PgQrcodeComponent implements OnChanges, AfterViewChecked {

    @Input() text:string;
    @Input() options:QRCodeRenderersOptions;
    /** Optional accessible name; defaults to localized "QR code for {{text}}". */
    @Input() ariaLabel:string;

    @ViewChild('QRCanvas') QRCanvas:ElementRef;

    constructor(private localizationService:LocalizationService) { }

    private _mustRender = false;

    ngOnChanges(): void {
        this._mustRender = true;
    }

    ngAfterViewChecked(): void {
        if(this._mustRender) {
            this._mustRender = false;
            toCanvas(this.QRCanvas.nativeElement, this.text, this.options);
        }
    }

    getAriaLabel() {
        if(this.ariaLabel != null && this.ariaLabel !== '') return this.ariaLabel;
        return this.localizationService.translate('pg-qrcode.a11y-label', { text: this.text || '' });
    }
}
